import { modalTitle } from "~/components/BTSInProductVideoPage/Review/Modals/Modals.css";
import { RateModalStars } from "~/components/BTSInProductVideoPage/Review/Modals/RateModal/RateModalStars";
import { reviewModalTitle } from "~/components/BTSInProductVideoPage/Review/ReviewFormOrchestrator/utils";
import { button } from "~/components/BTSInProductVideoPage/SeriesDetails/SeriesDetails.css";
import { useAllReviewModalFunctions } from "~/hooks/review/useReviewModal";

import * as styles from "./RateSeries.css";

export const RateSeries = ({
  productId,
  isLastVideo,
  handleRateLater,
  handleRateAtEnd,
  productReviewScore,
  updateReviewScore,
}: {
  productId: string;
  isLastVideo: boolean;
  productReviewScore: number;
  handleRateLater: () => void;
  handleRateAtEnd: () => void;
  updateReviewScore: (data: { productId: string; reviewScore: number }) => void;
}) => {
  const { updateActiveReviewModal, setLastClassVideo } = useAllReviewModalFunctions();

  return (
    <div className={styles.container}>
      <h3 className={modalTitle}>{reviewModalTitle(isLastVideo)}</h3>
      <RateModalStars
        productReviewScore={productReviewScore}
        setProductReviewScore={(value: number) => {
          updateReviewScore({ productId, reviewScore: value });
          updateActiveReviewModal();
          setLastClassVideo(isLastVideo);
        }}
      />
      {!isLastVideo && (
        <div className={styles.buttonsContainer}>
          <button className={button} onClick={handleRateLater}>
            Ask me later
          </button>
          <button className={styles.ctaButton} onClick={handleRateAtEnd}>
            Ask me at the end of class
          </button>
        </div>
      )}
    </div>
  );
};
